import { convertDate } from ".";

const utcDate = (dateTime: string, format = "MMMM DD YYYY") =>
  new Date(convertDate(dateTime, format)).toUTCString();

export default utcDate;
